import Api from "../../config/ApiConfig";
import { IOverrideSearchParam, IOverridePostReq, IOverridePutReq } from "./types";

const apiUrls = {
  searchOverrides: "api/v1/searches/overrides",
  getOverrides: "api/v1/overrides"
};

export const getParam = (param: string[] | undefined, paramType: string) => {
  let str: string = '';
  if (param && param?.length > 0) {
    str = `&${paramType}=${param}`;
  }
  return str;
}

export const getNumbericParam = (param:  number | null | undefined, paramType: string) => {
  let str: string = '';
  if (param) {
    str = `&${paramType}=${param}`;
  }
  return str;
}

export const getOverrides = (params : IOverrideSearchParam) =>
    Api.get(`${apiUrls.searchOverrides}?skip=${params.skip}&top=${params.top}&count=${params.count}&orderby=${params.orderby}&queryType=full&search=${params.search}` +
        getParam(params.tableId, "tableId") + getParam(params.grantee, "grantee") + getParam(params.sourceId, "sourceId")
        + getParam(params.treatmentLevel, "treatmentLevel")
        + getNumbericParam(params.daysToExpiry, "daysToExpiry"))
        .then((response) => { return response })
        .catch((error) => { return error.response });   


export const postOverride = (payload : IOverridePostReq[]) => 
    Api.post(apiUrls.getOverrides, payload)
        .then((response) => { return response })
        .catch((error) => {return error.response });
    

export const getOverrideDetails = (param: string) => 
    Api.get(apiUrls.getOverrides + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
    

export const deleteOverride = (param: string) => 
    Api.delete(apiUrls.getOverrides + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
        

export const putOverride = (param: string, payload : IOverridePutReq) => 
    Api.put(apiUrls.getOverrides + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });
